import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { rel } from '@ifeng-fe/ui_rel';

/**
 * 定义 Footer 组件
 */
class Footer extends React.PureComponent {
    static propTypes = {
        // content: PropTypes.object,
    };

    state = {
        content: {
            nav: [
                {
                    title: '凤凰新媒体介绍',
                    url: '//www.ifeng.com/corp/about/intro/',
                },
                {
                    title: '投资者关系 Investor Relations',
                    url: '//ir.ifeng.com/',
                },
                {
                    title: '广告服务',
                    url: '//biz.ifeng.com/',
                },
                {
                    title: '诚征英才',
                    url: '//career.ifeng.com/',
                },
                {
                    title: '保护隐私权',
                    url: '//www.ifeng.com/corp/privacy/',
                },
                {
                    title: '免责条款',
                    url: '//www.ifeng.com/corp/exemption/',
                },
                {
                    title: '意见反馈',
                    url: '//www.ifeng.com/corp/feedback/',
                },
                {
                    title: '凤凰卫视介绍',
                    url: '//phtv.ifeng.com/intro/',
                },
                {
                    title: '京ICP证030609号',
                    url: 'https://beian.miit.gov.cn/',
                },
            ],
            content: {
                text0: '凤凰新媒体',
                text1: '版权所有',
                text2: 'Copyright © 2016 Phoenix New Media Limited All Rights Reserved.',
            },
        },
    };

    /**
     * 渲染组件
     */
    render() {
        const {
            content: { nav, content },
        } = this.state;

        return (
            <div className={styles.footer}>
                <div className={`${styles.foot_link} clearfix`}>
                    <div className={styles.list}>
                        {nav.map((item, index) => (
                            <a key={index} className={styles.link} href={item.url} target="_blank" rel={rel}>
                                {item.title}
                            </a>
                        ))}
                    </div>
                </div>
                <div className={styles.copyright}>
                    <span>{content.text0}</span>
                    <span>{content.text1}</span>
                </div>
                <div className={styles.copyright}>
                    <span>{content.text2}</span>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Footer);
